// import actionTypes from '../../utils/action-types';
import { ACTION_TYPES } from '../../constants';

const initialState = {
  currentCoords: null,
};

const selectionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_CURR_COORDS:
      // console.log('Reducer updating currentCoords:', action.payload);
      return { ...state, currentCoords: action.payload }; // ✅ Ensure it updates
    default:
      return state;
  }
};

export default selectionsReducer;
